import Image from 'next/image'

import { config } from '../config'
import { SubTitle } from '../styles'

import { Card, Title, TitleWrapper, Wrapper } from './styles'

const {
  technologies: { cards, hexagonImage },
} = config

export function MarketAnalysis() {
  return (
    <Wrapper>
      {cards.map(({ title, subtitle }) => (
        <Card key={title}>
          <TitleWrapper>
            <Image {...hexagonImage} />
            <Title as="h2">{title}</Title>
          </TitleWrapper>
          <SubTitle>{subtitle}</SubTitle>
        </Card>
      ))}
    </Wrapper>
  )
}
